/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/PageHeader";
import { isEmpty } from "lodash";
import useForm from "../../../hooks/useForm";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { CardList } from "../../../components/List";
import Icon from "../../../components/Icon";
import BoardIcon from "../../../assets/images/icon/board-writing.svg";
import Button from "../../../components/Button";
import { preventEvent } from "../../../utils/element";
import { getTaxConsultingCategories, getTaxConsultingContent } from "../../../apis/tax-portal/tax-consulting";
import { dps } from "../../../utils/lodashExtend";
import Loading from "../../../components/Loading";
import EditButton from "../../../assets/images/icon/edit-btn.svg";

import taxConsultingTopImage from "../../../assets/images/tax-portal/tax-consulting/tax-consulting-category-top-banner.jpg";
import DetailTaxConsultingCategory from "./DetailTaxConsultingCategory";
import { isNumber } from "../../../utils/number";
import { findCategoryManager } from "../../../utils/tax-consulting";
import { TAX_CONSULTING_CATEGORY_INFO } from "../../../constants/TaxPortal/TAX_CONSULTING_TYPE";
import { isAdmin } from "../../../utils/auth";
import NoData from "../../../components/NoData/NoData";
import systemAlert from "../../../utils/systemAlert";


const TaxConsultingList = (props) => {
  const searchParams = new URLSearchParams(props?.location?.search);
  const [categoryIdx, setCategoryIdx] = useState(null);
  const history = useHistory();

  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [fields, setFields] = useState([]);

  const [categoryList, setCategoryList] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState([]);
  const [isTopCategory, setIsTopCategory] = useState(false);

  const [headerButtons, setHeaderButtons] = useState([]);

  const [myManager, setMyManager] = useState(null);

  const _setActiveTab = (value) => {
    history.push(`/tax-portal/tax-consulting?mainCategoryIdx=${value}`);
  };

  useEffect(() => {
    if (isEmpty(employee)) {
      setFields([]);
      return;
    }

    setFields([
      {
        onValue: (_d, _f, datas) => {
          const categoryInfo = TAX_CONSULTING_CATEGORY_INFO.find((item) => item.label === datas.name);
          const manager = datas.manager || myManager;
          const isUpdate = datas.isUpdate;

          return (
            <div
              className="list-item"
              onClick={() => {
                if (!manager && datas.defaultRole !== "READ") {
                  systemAlert("접근이 불가한 카테고리입니다.");
                  return;
                }
                history.push(`/tax-portal/tax-consulting?categoryIdx=${datas.idx}${!isEmpty(datas?.boards) ? `&boardIdx=${datas?.boards[0].idx}` : ""}`);
              }}
            >
              {isUpdate && <div className="update-point" />}
              <span className="circle-icon">
                <Icon
                  src={categoryInfo?.icon ? categoryInfo.icon : BoardIcon}
                  imageStyle={{
                    width: "50px",
                    height: "50px",
                  }}
                />
              </span>
              <p className="title"> {datas.name}</p>
              <div className="date-profile" style={{ right: "-15px" }}>
                {(manager?.isWrite || manager?.isAdmin || isAdmin()) ? (
                  <>
                    <Button
                      color="text"
                      style={{
                        padding: "6px 5px"
                      }}
                      onClick={((e) => {
                        preventEvent(e);
                        openDetail(datas);
                      })}
                      label={
                        <>
                          <Icon src={EditButton} />
                        </>
                      }
                    />
                  </>
                ) : (<></>)}
              </div>
            </div>
          );
        },
      },
    ]);

  }, [employee, myManager]);

  const {
    form,
    setSubmit,
    // LIST 용
    list, setList,
    isLoading, setIsLoading,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      order: [
        {
          idx: 'desc'
        }
      ],
      page: 0,
      limit: 10
    },
  );

  useEffect(() => {
    const mainCategoryIdx = searchParams.get('mainCategoryIdx');
    setCategoryIdx(mainCategoryIdx ? Number(mainCategoryIdx) : 1);
    setSubmit(submit);
  }, [history.location.pathname, props?.location?.search]);

  useEffect(() => {
    submit({ categoryIdx, ...form });
  }, [categoryIdx]);

  const submit = ({ categoryIdx }) => {
    if (isNumber(categoryIdx)) {
      setIsLoading(true);
      getTaxConsultingCategories()
        .then((res) => {
          const list = res.data.map((data) => {
            const isUpdate = data.childCategories?.find(f => f.isUpdate);

            return { ...data, label: <>{data.name} {isUpdate && <span className="error">*</span>}</>, value: data.idx, action: _setActiveTab, };
          });
          setCategoryList([...list]);

          let currentCategory = dps(list, Number(categoryIdx), 'childCategories');

          setCategoryInfo(currentCategory);
          setList(currentCategory?.childCategories);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (categoryInfo) {
      getTaxConsultingContent({})
        .then(res => {
          const categories = res.categories;
          const _myManager = findCategoryManager(categories, categoryInfo.idx);
          setMyManager(_myManager);
        });
    }
  }, [categoryInfo]);

  useEffect(() => {

    if (!isEmpty(categoryInfo) && employee) {
      setHeaderButtons([
        {
          isHide: () => {
            return !(myManager?.isWrite || myManager?.isAdmin || isAdmin());
          },
          label: `${categoryInfo ? `[${categoryInfo.name}]` : "카테고리"} 관리`,
          action: () => {
            setIsTopCategory(true);
            setSelectedCategory(categoryInfo);
            setDetailOpen(true);
          },
        },
      ]);
    }
  }, [categoryInfo, myManager, employee]);

  const openDetail = (data, e) => {
    setDetailOpen(true);
    setIsTopCategory(false);
    setSelectedCategory(data);
  };

  return (
    <div className="has-extend-header">
      {categoryInfo ?
        <div className="tax-consulting-categories-wrap">
          <PageHeader
            title={`컨설팅 - ${categoryInfo.name}`}
            buttons={headerButtons}
            tabList={categoryList}
            activeTab={categoryIdx}
          />
          <div className="tax-consulting-top">
            <img src={taxConsultingTopImage} alt="컨설팅" />
          </div>
          <div className="card-btn-wrap mt-22">
            {
              myManager?.isWrite && <Button
                label="카테고리 생성"
                action={() => {
                  setIsTopCategory(false);
                  setDetailOpen(true);
                }}
              />
            }
          </div>
          <CardList
            className={"tax-consulting-category-list"}
            fields={fields}
            isTable={false}
            list={list}
            isLoading={isLoading}
          />
          <DetailTaxConsultingCategory
            employee={employee}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            open={detailOpen}
            setOpen={setDetailOpen}
            submit={submit}
            parentCategoryIdx={categoryIdx}
            isTopCategory={isTopCategory}
          />
        </div>
        :
        isLoading
          ? <Loading />
          : <NoData text="컨설팅 카테고리가 존재하지 않습니다." />
      }
    </div>
  );
};

export default TaxConsultingList;
